export default __webpack_public_path__ + "static/18-8f7f656af0598ee177d8d0e4a2f870df.jpg";